import { createContext, useContext } from 'react';
import type { ChildDto, EventType, FamilyDto, MeDto, BabyEvent } from '@bb/shared/core';
import type { RecentDto } from './api';
import type { ThemeMode } from './lib';
import type { ToastData } from './components';

export interface EditorTarget {
  type: EventType;
  event?: BabyEvent;
  /** Новая запись с заполненным заранее содержимым (например, сторона груди). */
  preset?: Record<string, unknown>;
}

export interface AppCtx {
  me: MeDto;
  family: FamilyDto;
  child: ChildDto;
  /** Растёт после каждого изменения — экраны перезагружают данные. */
  version: number;
  bump(): void;
  reloadMe(): Promise<void>;
  toast(t: Omit<ToastData, 'id'>): void;
  openEditor(t: EditorTarget): void;
  openAdd(): void;
  openSettings(): void;
  /** Выбрать малыша (если в семье их несколько). */
  selectChild(id: string): void;
  /** Перейти в дневник на нужную дату. */
  openDiary(date: string): void;
  /** Перейти в «Прогресс». */
  openProgress(): void;
  /** Последние 48 часов выбранного малыша (обновляется после изменений и раз в 30 с). */
  recent: RecentDto | null;
  /** Идущие таймеры (кормление, бутылочка, сон, прогулка). */
  running: BabyEvent[];
  /** Открыть экран запуска/управления действием. */
  openAction(type: EventType, event?: BabyEvent): void;
  themeMode: ThemeMode;
  setThemeMode(m: ThemeMode): void;
  /** Общая обработка ошибок API. */
  fail(e: unknown): void;
}

export const Ctx = createContext<AppCtx | null>(null);

export function useApp(): AppCtx {
  const c = useContext(Ctx);
  if (!c) throw new Error('AppCtx is missing');
  return c;
}
